import {Color} from "../types/Color";

/**
 * the area range limits used to define small-job-ness
 * if AREA is below the high limit then it's a small job
 * @param DEFAULT_HIGH the default maximum area for a small job, but use useSmallJobs() to get the actual area
 */
export const SMALL_JOB_AREA = {
    DEFAULT_HIGH: 25,
};

export function isSmallProjectSquareFootage(totalSquareFootage: number): boolean {
    return isSmallJobArea(totalSquareFootage, SMALL_JOB_AREA.DEFAULT_HIGH);
}

export function isSmallJobArea(totalSquareFootage: number, highLimit: number): boolean {
    return totalSquareFootage < highLimit;
}

export function getSmallProjectFeeProductIDFromColor(selectedColor: Color): number | undefined {
    return selectedColor.smallProductFeeID;
}